import React from 'react';
import ReactDOM from 'react-dom';
import App from "./Components/app/app";

ReactDOM.render(<App/>, document.getElementById('root'));